/* eslint-disable import/prefer-default-export */
import pdfMake from 'addthaifont-pdfmake/build/pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import _ from 'lodash';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import THBText from 'thai-baht-text';

import currencyFormatterTH from '../../utils/functions/currencyFormatterTH';
import { ReportHeader } from './common';
import { PAYROLL_TYPE } from '../../utils/constants';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};

export const DailyOrMonthyPayrollReport = (
  employees,
  information,
  option = {
    startDate: '',
    endDate: '',
    payroll_type: '',
    filterUsingDate: false,
    selectedDate: '',
  },
  isError,
) => {
  console.log('employees', employees);

  const genEmployee = (data) =>
    _.map(data, (_data, index) => [
      {
        text: index + 1,
        border: [true, false, true, true],
        fontSize: 10,
        colSpan: 1,
        alignment: 'center',
      },
      {
        text: `${_data?.employee?.firstname || ''} ${
          _data?.employee?.lastname || ''
        }`,
        border: [true, false, true, true],
        fontSize: 10,
        colSpan: 1,
      },
      {
        text:
          option.payroll_type === PAYROLL_TYPE.MONTHY.status_code
            ? 'ค่าตอบแทนรายเดือน'
            : `${dayjs(_data?.daily_attribute?.start_time).format(
                'HH:mm',
              )} - ${dayjs(_data?.daily_attribute?.end_time).format('HH:mm')}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'center',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.main_cost)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.total_overtime)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.total_cost)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
    ]);

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 30, 40, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '16',
    },
    info: {
      title: 'รายการค่าตอบแทนพนักงาน',
    },
    content: [
      isError ? ReportHeader(information, false) : ReportHeader(information),
      {
        // หัวข้อ
        alignment: 'center',
        margin: [0, 15, 0, 10],
        text: 'รายการค่าตอบแทนพนักงาน',
        fontSize: '16',
        bold: true,
      },
      option?.filterUsingDate
        ? {
            style: 'tableExample',
            table: {
              widths: ['10%', '35%', '25%', '35%'],
              heights: [15],
              body: [
                [
                  {
                    text: 'วันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      dayjs(option?.selectedDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? 'ประเภทค่าตอบแทน'
                        : '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? PAYROLL_TYPE[option?.payroll_type]?.description
                        : '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          }
        : {
            style: 'tableExample',
            table: {
              widths: ['10%', '35%', '15%', '35%'],
              heights: [15],
              body: [
                [
                  {
                    text: 'ตั้งแต่วันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: dayjs(option?.startDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: 'ถึงวันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: dayjs(option?.endDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? 'ประเภท\nค่าตอบแทน'
                        : '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? PAYROLL_TYPE[option?.payroll_type]?.description
                        : '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },

                  {
                    text: '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
      {
        margin: [0, 5, 0, 0],
        style: 'tableExample',
        table: {
          widths: ['10%', '*', '20%', '10%', '10%', '10%'],
          heights: [15],
          body: [
            [
              {
                text: 'ลำดับ',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ชื่อ-นามสกุล',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ช่วงเวลาทำงาน',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ค่าตอบแทนปกติ',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ค่าล่วงเวลา',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'รวม',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
            ],
            ...genEmployee(employees),
            [
              {
                text: 'รวม',
                colSpan: 3,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {},
              {},
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(employees, (eachEmployee) => eachEmployee?.main_cost),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(
                      employees,
                      (eachEmployee) => eachEmployee?.total_overtime,
                    ),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(
                      employees,
                      (eachEmployee) => eachEmployee?.total_cost,
                    ),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
            ],
          ],
        },
      },
    ],
    // images: {
    //   logo: information?.logo?.url,
    // },
  };
  pdfMake.createPdf(docDefinition).open();
};
